<template>
  <div>
    <el-button type="warning" size="mini" @click="checkRefund"
      >查看退款</el-button
    >
    <el-dialog
      title="查看退款:"
      ref="checkRefundRef"
      :visible.sync="dialogFormVisible"
      class="refund-dialog"
      width="70%"
      :before-close="dialogClose"
    >
      <ApeTable
        ref="apeTable"
        :columns="columns"
        :loading="loadingStatus"
        :pagingData="pagingData"
        :data="refundList"
        @switchPaging="switchPaging"
      >
        <template slot="first-column">
          <el-table-column type="index" label="编号" align="center" />
        </template>
        <template>
          <el-table-column
          v-if="isAlipay"
          align="center"
          label="申请退款金额"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{
              parseFloat(scope.row.money).toFixed(2)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          align="center"
          label="申请退款金额(含服务费)"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{
              parseFloat(scope.row.money).toFixed(2)
            }}</span>
          </template>
        </el-table-column>
        </template>
       <template>
        <el-table-column
          v-if="isAlipay"
          align="center"
          label="实际退款金额"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{
              (parseFloat(scope.row.money) + parseFloat(scope.row.tax)).toFixed(
                2
              )
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          align="center"
          label="实际退款金额(不含服务费)"
          width="200"
        >
          <template slot-scope="scope">
            <span>{{
              (parseFloat(scope.row.money) - parseFloat(scope.row.tax)).toFixed(
                2
              )
            }}</span>
          </template>
        </el-table-column>
       </template>

        <el-table-column align="center" label="状态">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="您的退款被驳回，请联系客服解决"
              placement="bottom"
              v-if="scope.row.status === '02'"
            >
              <div style="color:#F56C6C ">{{ scope.row.status_alias }}</div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="'您的退款正在' + scope.row.status_alias"
              placement="bottom"
              v-if="scope.row.status === '00'"
            >
              <div style="color:#409EFF ">{{ scope.row.status_alias }}</div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="'您的退款' + scope.row.status_alias"
              placement="bottom"
              v-if="scope.row.status === '01'"
            >
              <div style="color:#F4CE66 ">{{ scope.row.status_alias }}</div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="'您的退款' + scope.row.status_alias"
              placement="bottom"
              v-if="scope.row.status === '11'"
            >
              <div style="color:#67C23A ">{{ scope.row.status_alias }}</div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="'您的退款' + scope.row.status_alias"
              placement="bottom"
              v-if="scope.row.status === '91'"
            >
              <div style="color:#67C23A ">{{ scope.row.status_alias }}</div>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              :content="'您的退款' + scope.row.status_alias"
              placement="bottom"
              v-if="scope.row.status === '99'"
            >
              <div style="color:#F56C6C ">{{ scope.row.status_alias }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
      </ApeTable>
    </el-dialog>
  </div>
</template>
<script>
import ApeTable from "../components/ApeTable";

export default {
  components: {
    ApeTable,
  },
  props:{
    isAlipay:Boolean
  },
  data() {
    return {
      dialogTableVisible: false,
      dialogFormVisible: false,
      loadingStatus: false,
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 退款数据
      refundList: [],
      columns: [
        // {
        //   title: "编号",
        //   value: "id",
        //   width: 50,
        //   header_align: "center",
        //   align: "center",
        // },
        {
          title: "申请退款时间",
          value: "created_at",
          width: 200,
          header_align: "center",
          align: "center",
        },
        // {
        //   title: "申请退款金额(含服务费)",
        //   width: 200,
        //   header_align: "center",
        //   align: "center",
        //   value: "money",
        // },
        {
          title: "服务费退款",
          width: 100,
          header_align: "center",
          align: "center",
          value: "tax",
        },
        {
          title: "退款公司",
          width: 200,
          header_align: "center",
          align: "center",
          value: "refund_company_name",
        },
        {
          title: "服务公司",
          width: 200,
          header_align: "center",
          align: "center",
          value: "channel_name",
        },
      ],
    };
  },
  computed: {
    switchInfo() {
      return this.$store.state.switchInfo;
    },
  },
  methods: {
    dialogClose() {
      this.dialogFormVisible = false;
    },
    async checkRefund() {
      this.dialogFormVisible = true;
      const result = await this.$api.checkRefundList({
        company_id: this.switchInfo.nowCompany.id,
        channel_account: this.switchInfo.settlementId,
      });
      this.refundList = result.data;
      this.pagingData.total = result.page.total;
      this.offset = result.page.offset;
    },
    // 切换分页
    async switchPage() {
      this.dialogFormVisible = true;
      this.loadingStatus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo();
      const result = await this.$api.checkRefundList({
        page_size: pagingInfo.page_size,
        current_page: pagingInfo.current_page,
        company_id: this.switchInfo.nowCompany.id,
        channel_account: this.switchInfo.settlementId,
      });
      this.refundList = result.data;
      this.pagingData.total = result.page.total;
      this.offset = result.page.offset;
      this.loadingStatus = false;
    },
    async switchPaging() {
      await this.switchPage();
    },
  },
};
</script>
<style scoped>
.refund-dialog /deep/ .el-dialog .el-dialog__body {
  padding: 30px 30px !important;
}

.refund-dialog /deep/ .el-dialog .el-dialog__header span {
  display: inline-block;
  border-left: 5px solid #1890ff;
  padding-left: 10px;
  height: 24px;
  color: #101010;
}

.refund-dialog /deep/ .el-dialog .el-dialog__header {
  padding-bottom: 20px !important;
}

.refund-dialog /deep/ .el-dialog .el-dialog__body {
  padding-top: 0 !important;
}
>>> .el-dialog {
  margin-top: 5vh !important;
  overflow: scroll;
  height: 800px;
}
</style>
